const rankingItems = [
  { rank: 1, title: '《长安十二时辰》第二季', type: '电视剧', hot: '热度 9.8', change: 'up' },
  { rank: 2, title: '《星际迷航：新纪元》', type: '电影', hot: '热度 9.6', change: 'up' },
  { rank: 3, title: '《咒术回战》第三季', type: '动漫', hot: '热度 9.5', change: 'same' },
  { rank: 4, title: '《乘风破浪的姐姐》S6', type: '综艺', hot: '热度 9.3', change: 'up' },
  { rank: 5, title: '《迷雾追踪》', type: '电影', hot: '热度 9.1', change: 'down' },
  { rank: 6, title: '《繁花》导演剪辑版', type: '电视剧', hot: '热度 8.9', change: 'up' },
  { rank: 7, title: '《脱口秀大会》第七季', type: '综艺', hot: '热度 8.7', change: 'same' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[800px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2 text-center">
          热度榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">本周最受欢迎的影视内容排行</p>
        <div className="rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden">
          {rankingItems.map((r, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 py-4 border-b border-background-200/60 last:border-0 hover:bg-background-50 transition-colors cursor-pointer ${
                r.rank <= 3 ? 'bg-primary-50/30' : ''
              }`}
            >
              <span
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                  r.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : r.rank === 2
                    ? 'bg-accent-500 text-background-50'
                    : r.rank === 3
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {r.rank}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-foreground-800 truncate">{r.title}</p>
                <p className="text-xs text-foreground-400">{r.type}</p>
              </div>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{r.hot}</span>
              <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                {r.change === 'up' && <i className="ri-arrow-up-fill text-primary-500 text-xs"></i>}
                {r.change === 'down' && <i className="ri-arrow-down-fill text-red-400 text-xs"></i>}
                {r.change === 'same' && <i className="ri-subtract-line text-foreground-400 text-xs"></i>}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}